// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1owZY","inputDescription":"styles_inputDescription__qTm77"};